import React from 'react';
import { SvgIcon } from '@material-ui/core';

const GameIcon = (props) => {
  return (
      <img class="homeicon" viewBox="0 0 24 24" src="./images/games.svg" alt="" />
  );
};

export default GameIcon;
